import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { getSPDataWithParams } from 'src/supportPortal/services/services'

export async function getMinimalMentorData(
  slug,
  forceFetch = false,
  fetchApiSignature = '/api/secure/cc/support/therapists/by-slug',
) {
  const sessionTherString = sessionStorage.getItem('supportMentorData')
  const sessionTher = JSON.parse(sessionTherString)
  if (sessionTher && sessionTher?.slug === slug && !forceFetch) {
    return sessionTher
  }

  const resp = await getSPDataWithParams(fetchApiSignature, {
    slug: slug,
  })
  console.log({ resp })
  if (resp && isCommonResponseSuccessfulV2(resp)) {
    const dat = getDataMapFromCommonResponse(resp)?.mentor

    console.log({ dat })
    sessionStorage.setItem('supportMentorData', JSON.stringify(dat))

    return dat
  }
}

export async function getAllOneOnOnePlansForSupportPortal(mentorSlug) {
  const resp = await getSPDataWithParams('/api/secure/cc/support/1on1-plans', {
    mentorSlug: mentorSlug,
  })
  if (resp?.status === 200) {
    if (resp?.data) {
      return resp?.data
    }
  }
}
